function household_tab(e, t) {
  var s, a, l;
  if (
    ((a = document.getElementsByClassName("tabcontent")),
    (l = document.getElementsByClassName("tablinks")),
    "All" === t)
  ) {
    for (s = 0; s < a.length; s++) a[s].style.display = "block";
    for (s = 0; s < l.length; s++) l[s].className = "tablinks";
  } else {
    for (s = 0; s < a.length; s++) a[s].style.display = "none";
    for (s = 0; s < l.length; s++) l[s].className = "tablinks";
    (document.getElementById(t).style.display = "block"),
      (e.currentTarget.className += " active");
  }
}
var firstParentDiv,
  tablinks = document.querySelectorAll(".tablinks");
tablinks.forEach(function (e) {
  e.addEventListener("click", function () {
    tablinks.forEach(function (e) {
      e.classList.remove("active");
    }),
      this.classList.add("active");
  });
});
var parentDivs = document.getElementsByClassName("household-tab");
parentDivs.length > 0 &&
  parentDivs[0].firstElementChild.classList.add("active");
